import {DEV_DOMAIN, DEV_URLS, PROD_DOMAIN} from '../credentials';
import {getCookie} from './getCookie';

export const getDomain = () => {
  const hostname = window.location.hostname;
  const apiEnvCookie = getCookie('api_env');

  if (apiEnvCookie === 'dev' || (!apiEnvCookie && DEV_URLS.includes(hostname))) {
    return DEV_DOMAIN;
  }

  return PROD_DOMAIN;
};
